// Injected at build time by vite.config.ts (define block).
declare const __APP_BUILD_SHA__: string;
declare const __APP_BUILD_TIME__: string;

export type Environment = 'prod' | 'staging' | 'dev' | 'local';

export function detectEnvironment(host: string = location.hostname): Environment {
  if (host === 'asmaluz.com' || host === 'www.asmaluz.com') return 'prod';
  if (host.startsWith('staging.')) return 'staging';
  if (host.startsWith('dev.')) return 'dev';
  return 'local';
}

export function buildStampText(env: Environment = detectEnvironment(), sha: string = __APP_BUILD_SHA__): string {
  return `asmaluz-shop · ${env} · ${sha}`;
}

export function renderBuildStamp(parent: HTMLElement, className = 'login__build-stamp'): HTMLElement {
  const stamp = document.createElement('p');
  stamp.className = className;
  stamp.textContent = buildStampText();
  stamp.title = `Built at ${__APP_BUILD_TIME__}`;
  parent.appendChild(stamp);
  return stamp;
}
